import axios from 'axios';
import BaseApi from '@/api/base';
import { Url } from '@/constants';
import { getImpersonationParams } from '@/util';
import helper from '@/util/case-helper';
import { AppointmentLocations, DesignCenterLocationElement } from '@/types';

const setAppointmentsHeader = (params = {}) => ({
  ...params,
  headers: {
    type: 'PORTAL'
  }
});

const getAllAppointments = (data: any, params = {}) => BaseApi.post('appointment/all', data, { params: getImpersonationParams(), ...setAppointmentsHeader(params) });

const getPendingAppointments = (jobId: string, divisionId: string, email: string, includeOptionalAppointment = 1) => BaseApi.get(`appointment/unschedule/${divisionId}/${jobId}/${includeOptionalAppointment}`, { params: getImpersonationParams({ buyerEmail: email }), ...setAppointmentsHeader() });

const getAppointmentDetails = (appointmentId: any) => BaseApi.get(`appointment/${appointmentId}`, { params: getImpersonationParams(), ...setAppointmentsHeader() });

const getTimeZones = () => BaseApi.get(`${Url.localBaseUrl}/data/timezones.json`, {});

const getAvailableTimeSlots = (teamMemberId: number, duration: number, startDate: string, endDate: string, isAll: string, params = {}) => BaseApi.get(`appointment/availability/${teamMemberId}/${duration}/${isAll}/${startDate}/${endDate}`, setAppointmentsHeader({ params: getImpersonationParams(params) }));

const getTeamMembers = (jobId: string, params = {}) => BaseApi.get(`buyer/job/${jobId}/teamMember`, { params });

const getDivisionDreesMembers = (divisionId: string, config: any) => BaseApi.get(`divisionTeamMember/${divisionId}`, setAppointmentsHeader(config));

const getSupervisorData = (teamMemberId: number, params = {}) => BaseApi.get(`teammember/supervisor/${teamMemberId}`, setAppointmentsHeader(params));

const getAppointmentTypeDetails = (appointmentTypeId: string, params = {}) => BaseApi.get(`appointment/appointment_type/${appointmentTypeId}`, setAppointmentsHeader(params));

const createAppointment = (data: any, params = {}) => BaseApi.post('appointment/create', data, setAppointmentsHeader(params));

const modifyAppointment = (data: any, params = {}) => BaseApi.post('appointment/update', data, setAppointmentsHeader(params));

const cancelAppointment = (data: any) => BaseApi.deleteStream('appointment/delete', data, setAppointmentsHeader());

const getAppointmentLocations = async (areaId: string) => {
  try {
    const res = await axios.get(process.env.VUE_APP_APPOINTMENT_LOCATIONS_API) as any;
    const locations = helper.snakeToCamel(res.data.locations) as AppointmentLocations;
    return locations.designCenterLocations.find((loc) => loc.areaId.toLowerCase() === areaId.toLowerCase()) || {} as DesignCenterLocationElement;
  } catch (error) {
    console.log(error);
    return {} as DesignCenterLocationElement;
  }
};

export {
  getAllAppointments,
  getPendingAppointments,
  getTimeZones,
  getAvailableTimeSlots,
  getTeamMembers,
  getSupervisorData,
  getAppointmentDetails,
  getAppointmentTypeDetails,
  createAppointment,
  modifyAppointment,
  cancelAppointment,
  getAppointmentLocations,
  getDivisionDreesMembers
};
